import { CessationEmployeeModel, EmployeeModel, IEmployee } from '@/models/config'
import { documentTypes } from '../constants'
import { TYPE_CESSATION, TYPE_RE_ENTRY } from '@/constants/cessationEmployee'
import moment from 'moment'

const getTextDocumentType = (value: number): string => {
  const doc = documentTypes.find(type => type.value === value)
  if (doc) {
    return doc.text
  }
  return ''
}

const getFullNameFormat = (employee: EmployeeModel): string => {
  return `${employee.last_name} ${employee.mothers_last_name}, ${employee.name} - ${getTextDocumentType(employee?.document_type || 0)}: ${employee.document_number}`
}

const createHtmlEmploteeInfo = (employee: EmployeeModel) => {
  return `${employee.last_name} ${employee.mothers_last_name},<br/> ${employee.name} ${getTextDocumentType(employee?.document_type || 0)}: ${employee.document_number}`
}

const getFullNameOnlyFormat = (employee: EmployeeModel): string => {
  return `${employee.last_name} ${employee.mothers_last_name}, ${employee.name}`
}

const getListDateAvailable = (listCessation: CessationEmployeeModel[]): string[] => {
  const listDate: string[] = []
  let lastDate: string | null = null
  if (listCessation.length > 0) {
    for (let i = 0; i < listCessation.length; i++) {
      const element = listCessation[i]
      if (element.type === TYPE_RE_ENTRY) {
        listDate.push(element.date)
        lastDate = element.date
      } else if (element.type === TYPE_CESSATION) {
        const dateInit = moment(lastDate)
        const dateEnd = moment(element.date)
        while (dateInit.toDate() < dateEnd.toDate()) {
          dateInit.add(1, 'days')
          listDate.push(dateInit.format('YYYY-MM-DD'))
        }
      }
    }
  }
  return listDate
}

const isWorkingInDate = (employee: IEmployee, date: string) => {
  if (date) {
    if (employee.cessation.length === 1 && employee.cessation[0].type === TYPE_RE_ENTRY) {
      if (employee.cessation[0].date <= date) {
        return true
      } else {
        return false
      }
    } else if (employee.cessation.length === 2) {
      const cessationEntry = employee.cessation.find(c => c.type === TYPE_RE_ENTRY)
      const cessationExit = employee.cessation.find(c => c.type === TYPE_CESSATION)
      if (cessationEntry && cessationExit && (cessationEntry.date <= date && date <= cessationExit.date)) {
        return true
      }
      return false
    } else if (employee.cessation.length > 2) {
      const dateAvailables = getListDateAvailable(employee.cessation)
      if (dateAvailables.find(d => d === date)) {
        return true
      } else {
        const lastCessation = employee.cessation[employee.cessation.length - 1]
        if (lastCessation.type === TYPE_RE_ENTRY && lastCessation.date <= date) {
          return true
        }
      }
    }
  }
  return false
}

export {
  getTextDocumentType,
  getFullNameFormat,
  createHtmlEmploteeInfo,
  getListDateAvailable,
  getFullNameOnlyFormat,
  isWorkingInDate
}
